import { TagType } from "dto/ITag";
import { ListType } from "dto/ListType";

export const getTagTypeForListType = (list: ListType) => {
  switch (list) {
    case ListType.Incoming:
      return TagType.Incoming;
    case ListType.Outgoing:
      return TagType.Outgoing;
    case ListType.Cases:
      return TagType.Cases;
    case ListType.Participants:
      return TagType.Participants;
    case ListType.EditorDocuments:
    case ListType.Templates:
      return TagType.EditorDocuments;
    case ListType.Tasks:
      return TagType.Tasks;
    default:
      return TagType.Other;
  }
};
